var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isBulletinRoute &&
    !_vm.isRoleViewer &&
    !_vm.isOnlyAdminOrSpecialist &&
    _vm.bulletinUnreadCount > 0
    ? _c(
        "div",
        { staticClass: "bulletin-notification" },
        [
          _c("span", [_vm._v("Határidős feladat a Faliújságon!")]),
          _c(
            "router-link",
            { attrs: { to: "/neta/bulletin" } },
            [
              _c("a-button", { staticClass: "view-button" }, [
                _vm._v("\n      Megtekintem\n    ")
              ])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }